import React from 'react';

export const Nav30DataSource = {
    wrapper: {className: 'header3 home-page-wrapper'},
    page: {className: 'home-page'},
    logo: {
        className: 'header3-logo k4xuc7j965t-editor_css',
        children: 'https://img.springlearn.cn/tomato-logo.png',
    },
    Menu: {
        className: 'header3-menu',
        children: [
            {
                name: 'item0',
                className: 'header3-item',
                children: {
                    href: '#',
                    children: [
                        {
                            children: (
                                <>
                                    <p>
                                        <span>首页</span>
                                        <br/>
                                    </p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                },
                subItem: null,
            },
            {
                name: 'item1',
                className: 'header3-item',
                children: {
                    href: 'https://github.com/lxchinesszz/tomato',
                    children: [
                        {
                            children: (
                                <>
                                    <p>教程</p>
                                </>
                            ),
                            name: 'text',
                        },
                    ],
                    target: '_blank',
                },
            },
            {
                name: 'item2',
                className: 'header3-item',
                children: {
                    href: 'https://blog.springlearn.cn',
                    children: [
                        {
                            children: (
                                <>
                                    <p>作者博客</p>
                                </>
                            ),
                            name: 'text',
                            className: 'k4xtgfl3ba-editor_css',
                        },
                    ],
                    target: '_blank',
                },
            },
        ],
    },
    mobileMenu: {className: 'header3-mobile-menu'},
};
export const Banner50DataSource = {
    wrapper: {className: 'home-page-wrapper banner5'},
    page: {className: 'home-page banner5-page'},
    childWrapper: {
        className: 'banner5-title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <div>
                        <p>Tomato<span className="subscript">2.0</span></p>
                    </div>
                ),
                className: 'banner5-title',
            },
            {
                name: 'explain',
                className: 'banner5-explain',
                children: (
                    <>
                        <p>开箱即用 「SpringBoot3.0定制」</p>
                    </>
                ),
            },
            {
                name: 'content',
                className: 'banner5-content',
                children: (
                    <>
                        <p>聚焦业务逻辑，让天下没有难写的防重代码</p>
                        <p>语法丰富，完美支持SpringEL表达式</p>
                    </>
                ),
            },
            // {
            //   name: 'button',
            //   className: 'banner5-button-wrapper',
            //   children: {
            //     href: '#',
            //     className: 'banner5-button',
            //     type: 'primary',
            //     children: '开始使用',
            //   },
            // },
        ],
    },
    image: {
        className: 'banner5-image k4xt9h6tgp-editor_css',
        children: 'https://img.springlearn.cn/undraw_hacker_mind_6y85.svg',
    },
};
export const Content130DataSource = {
    OverPack: {
        className: 'home-page-wrapper content13-wrapper k4xzti69nw-editor_css',
        playScale: 0.3,
    },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{name: 'image', children: '', className: 'title-image'}],
    },
};
export const Feature10DataSource = {
    wrapper: {className: 'home-page-wrapper content1-wrapper'},
    OverPack: {className: 'home-page content1', playScale: 0.3},
    imgWrapper: {className: 'content1-img', md: 10, xs: 24},
    img: {
        children:
            'https://img.springlearn.cn/learn_b76b706b334210df52dc476214198638.png',
        className: 'k4y04sjtaf9-editor_css',
    },
    textWrapper: {className: 'content1-text', md: 14, xs: 24},
    title: {
        className: 'content1-title',
        children: (
            <>
                <p>滑动窗口策略</p>
            </>
        ),
    },
    content: {
        className: 'content1-content',
        children: (
            <>
                <p>为每次到来的请求信息设置当前请求的控制时间，在控制时间内请求均会被有效拦截。从而防止暴力刷接口场景，提升应用安全性的防御能力。</p>
            </>
        ),
    },
};
export const Feature21DataSource = {
    wrapper: {className: 'home-page-wrapper content2-wrapper'},
    OverPack: {className: 'home-page content2', playScale: 0.3},
    imgWrapper: {className: 'content2-img', md: 10, xs: 24},
    img: {
        children:
            'https://img.springlearn.cn/learn_dce052d5cd83aedefdc69c9f58afa0cb.png',
        className: 'k4y0ewfbupu-editor_css',
    },
    textWrapper: {className: 'content2-text', md: 14, xs: 24},
    title: {
        className: 'content2-title',
        children: (
            <>
                <p>固定窗口策略</p>
            </>
        ),
    },
    content: {
        className: 'content2-content',
        children: (
            <>
                <p>
                    仅仅为第一次请求生成一个控制时间，控制时间内相同的请求会被拦截，控制时间过期后，以此类推。
                    该场景并不能防御暴力刷接口场景，因为在控制范围外总会放行一个请求进来。
                </p>
            </>
        ),
    },
};
export const Feature20DataSource = {
    wrapper: {className: 'home-page-wrapper content2-wrapper'},
    OverPack: {className: 'home-page content2', playScale: 0.3},
    imgWrapper: {className: 'content2-img', md: 10, xs: 24},
    img: {
        children: 'https://img.springlearn.cn/undraw_decorative_friends_q2np.png',
    },
    textWrapper: {className: 'content2-text', md: 14, xs: 24},
    title: {
        className: 'content2-title',
        children: (
            <>
                <p>分布式能力</p>
            </>
        ),
    },
    content: {
        className: 'content2-content',
        children: (
            <>
                <p>
                    Tomato的分布式能力并不是自身具有，而是依赖于Redis，从而达到分布式的能力。Tomato会通过特殊标识算法将自身数据与业务中使用Redis的数据隔离，从而达到互不影响的效果。所以无须担心会影响业务数据。
                </p>
            </>
        ),
    },
};
export const Feature40DataSource = {
    wrapper: {className: 'home-page-wrapper content6-wrapper'},
    OverPack: {className: 'home-page content6'},
    textWrapper: {className: 'content6-text', xs: 24, md: 10},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>快速使用</p>
                    </>
                ),
                className: 'title-h1',
            },
            {
                name: 'content',
                className: 'title-content',
                children: (
                    <>
                        <p>基于方法粒度进行拦截限制</p>
                    </>
                ),
            },
        ],
    },
    img: {
        children: 'https://img.springlearn.cn/blog/learn_1608907754000.png',
        className: 'content6-img',
        xs: 24,
        md: 14,
    },
    block: {
        children: [
            {
                name: 'block0',
                img: {
                    children:
                        'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
                    className: 'content6-icon',
                },
                title: {className: 'content6-title', children: '技术'},
                content: {
                    className: 'content6-content',
                    children: (
                        <>
                            <p>
                                基于Spring Aop拦截,通过Repeat、
                                TomatoToken配合注解方式,对方法粒度进行拦截。支持SpringEL表达式及HttpServletRequest表单类型。
                            </p>
                        </>
                    ),
                },
            },
            {
                name: 'block1',
                img: {
                    className: 'content6-icon',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
                },
                title: {className: 'content6-title', children: '融合'},
                content: {
                    className: 'content6-content',
                    children: (
                        <>
                            <p>通过隔离标识算法，保证业务数据双隔离。</p>
                        </>
                    ),
                },
            },
            {
                name: 'block2',
                img: {
                    className: 'content6-icon',
                    children:
                        'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
                },
                title: {className: 'content6-title', children: '开发'},
                content: {
                    className: 'content6-content',
                    children: (
                        <>
                            <p>
                                极低的学习成本，既可以通过简单的注解方式，达到重复数据校验拦截。同时也支持更高级的校验和扩展能力。
                            </p>
                        </>
                    ),
                },
            },
        ],
    },
};
export const Feature00DataSource = {
    wrapper: {className: 'home-page-wrapper content0-wrapper'},
    page: {className: 'home-page content0'},
    OverPack: {playScale: 0.3, className: ''},
    titleWrapper: {
        className: 'title-wrapper',
        children: [{name: 'title', children: '产品与服务'}],
    },
    childWrapper: {
        className: 'content0-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'jzjn8afnsxb-editor_css content0-block',
                md: 6,
                xs: 24,
                children: {
                    className: 'content0-block-item jzjgrrupf2c-editor_css',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon jzjgrlz134-editor_css',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title jzj8xt5kgv7-editor_css',
                            children: (
                                <>
                                    <p>开箱即用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>基于spring boot
                                        autoconfigure,自动化配置,使你在无需任何多余配置的情况下，即可使用。</p>
                                </>
                            ),
                            className: 'jzj8z9sya9-editor_css',
                        },
                    ],
                },
            },
            {
                name: 'block1',
                className: 'content0-block',
                md: 6,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon jzjncn210ql-editor_css',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title jzjne54fwqm-editor_css',
                            children: (
                                <>
                                    <p>数据隔离</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>标识算法保证数据的隔离，从而无污染业务数据。</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'content0-block',
                md: 6,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon jzjndq0dueg-editor_css',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title jzjne24af8c-editor_css',
                            children: (
                                <>
                                    <p>快速上手</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>原理简单，低学习成本，点击教程开始学习。</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block~jzjn87bmyc7',
                className: 'content0-block',
                md: 6,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon jzjndsyw8sf-editor_css',
                            children:
                                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title jzjndw5oerk-editor_css',
                            children: (
                                <>
                                    <p>快速扩展</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>简单的拦截原理，开源的协议，极低的学习成本，方便业务方定制与扩展。</p>
                                </>
                            ),
                        },
                    ],
                },
            },
        ],
    },
};
export const Feature81DataSource = {
    wrapper: {className: 'home-page-wrapper feature8-wrapper'},
    page: {className: 'home-page feature8'},
    OverPack: {playScale: 0.3},
    titleWrapper: {
        className: 'feature8-title-wrapper',
        children: [
            {name: 'title', className: 'feature8-title-h1', children: '使用流程'},
            {
                name: 'content',
                className: 'feature8-title-content',
                children: '流程简单清晰，快速响应需求',
            },
        ],
    },
    childWrapper: {
        className: 'feature8-button-wrapper',
        children: [
            {
                name: 'button',
                className: 'feature8-button',
                children: {
                    href: 'https://github.com/lxchinesszz/tomato',
                    children: '立即体验',
                    target: '_blank',
                    type: 'primary',
                },
            },
        ],
    },
    Carousel: {
        dots: false,
        className: 'feature8-carousel',
        wrapper: {className: 'feature8-block-wrapper'},
        children: {
            className: 'feature8-block',
            titleWrapper: {
                className: 'feature8-carousel-title-wrapper',
                title: {className: 'feature8-carousel-title'},
            },
            children: [
                {
                    name: 'block0',
                    className: 'feature8-block-row',
                    gutter: 120,
                    title: {
                        className: 'feature8-carousel-title-block',
                        children: '平台自主训练流程',
                    },
                    children: [
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child0',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: (
                                            <>
                                                <p>适用场景</p>
                                            </>
                                        ),
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: (
                                            <>
                                                <p>
                                                    凡是涉及到数据变更，方法调用，有可能出现并发重复提交问题的接口均可使用。
                                                    暴力刷接口场景下，也可使用。
                                                </p>
                                            </>
                                        ),
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child1',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: (
                                            <>
                                                <p>选择唯一键</p>
                                            </>
                                        ),
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: (
                                            <>
                                                <p>
                                                    如何判断是重复提交，比如同一订单编号在1ms内请求多次支付接口，那么我们就可以根据订单编号做防重处理。
                                                    具有唯一性的入参即可作为唯一键使用。
                                                </p>
                                            </>
                                        ),
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child2',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: (
                                            <>
                                                <p>选择防重策略</p>
                                            </>
                                        ),
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: (
                                            <>
                                                <p>固定窗口策略（重复提交，并发拦截）、滑动窗口策略（解决暴力刷接口场景，重复提交，并发拦截）</p>
                                            </>
                                        ),
                                    },
                                ],
                            },
                        },
                        {
                            className: 'feature8-block-col',
                            md: 6,
                            xs: 24,
                            name: 'child3',
                            arrow: {
                                className: 'feature8-block-arrow',
                                children:
                                    'https://gw.alipayobjects.com/zos/basement_prod/167bee48-fbc0-436a-ba9e-c116b4044293.svg',
                            },
                            children: {
                                className: 'feature8-block-child',
                                children: [
                                    {
                                        name: 'image',
                                        className: 'feature8-block-image',
                                        children:
                                            'https://gw.alipayobjects.com/zos/basement_prod/d8933673-1463-438a-ac43-1a8f193ebf34.svg',
                                    },
                                    {
                                        name: 'title',
                                        className: 'feature8-block-title',
                                        children: (
                                            <>
                                                <p>确定防重方式</p>
                                            </>
                                        ),
                                    },
                                    {
                                        name: 'content',
                                        className: 'feature8-block-content',
                                        children: (
                                            <>
                                                <p>
                                                    目前拦截器仅仅支持根据简单的唯一键来进行校验，如果不能满足你的业务，也支持自己实现。
                                                </p>
                                            </>
                                        ),
                                    },
                                ],
                            },
                        },
                    ],
                },
            ],
        },
    },
};
export const Footer20DataSource = {
    wrapper: {className: 'home-page-wrapper footer2-wrapper'},
    OverPack: {className: 'home-page footer2', playScale: 0.05},
    copyright: {
        className: 'copyright',
        children: [
            {
                name: 'image',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/NuuAwJBxewWglRSoNjET.png',
                className: 'copyright-logo',
            },
            {
                name: 'group',
                children: (
                    <>
                        <p>程序猿升级课</p>
                    </>
                ),
                className: 'copyright-group',
            },
            {
                name: 'image2',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/fgGmQUfiUfSBfvsQpfOj.svg',
                className: 'copyright-line',
            },
            {
                name: 'copyright',
                children: (
                    <>
                        <p>Copyright © 程序猿升级课</p>
                    </>
                ),
                className: 'copyright-text',
            },
        ],
    },
    links: {
        className: 'links',
        children: [
            {
                name: 'weibo',
                href: '#',
                className: 'links-weibo',
                children:
                    'data:image/svg+xml;base64,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',
            },
            {
                name: 'zhihu',
                href: '#',
                className: 'links-zhihu',
                children:
                    'data:image/svg+xml;base64,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',
            },
        ],
    },
};
